import {Form, Radio} from 'antd';

import {Locale} from '../../../provider/locale/locale';
import {AutoReplyRuleTypeEnum} from '../../../service/reviews/reviews-response-templates';

import {AutoReplyFormFieldNameEnum} from './auto-reply-form-const';
import * as styles from './auto-reply-form.scss';

type PropsType = {
    initialValue: AutoReplyRuleTypeEnum;
    isDisabled: boolean;
    isStoreOptionDisabled: boolean;
};

export function AutoReplyFormReviewTargetSelector(props: PropsType): JSX.Element {
    const {initialValue, isDisabled, isStoreOptionDisabled} = props;

    return (
        <Form.Item
            initialValue={initialValue}
            label={<Locale stringKey="AUTO_REPLIES__FORM__REVIEW_TARGET" />}
            name={AutoReplyFormFieldNameEnum.RuleType}
        >
            <Radio.Group className={styles.AutoReplyForm_reviewTargetGroup} disabled={isDisabled} size="large">
                <Radio.Button value={AutoReplyRuleTypeEnum.Company}>
                    <Locale stringKey="AUTO_REPLIES__FORM__REVIEW_TARGET__COMPANY" />
                </Radio.Button>
                <Radio.Button disabled={isStoreOptionDisabled} value={AutoReplyRuleTypeEnum.Store}>
                    <Locale stringKey="AUTO_REPLIES__FORM__REVIEW_TARGET__STORES" />
                </Radio.Button>
            </Radio.Group>
        </Form.Item>
    );
}
